import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-alert-exclamation-diamond.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M128 72a8 8 0 0 1 8 8v56a8 8 0 0 1-16 0V80a8 8 0 0 1 8-8m-12 100a12 12 0 1 0 12-12 12 12 0 0 0-12 12m124-44a15.85 15.85 0 0 1-4.67 11.28l-96.05 96.06a16 16 0 0 1-22.56 0l-96-96.06a16 16 0 0 1 0-22.56l96.05-96.06a16 16 0 0 1 22.56 0l96.05 96.06A15.85 15.85 0 0 1 240 128m-16 0-96-96-96 96 96 96Z" }, null, -1)])]);
}
var interface_alert_exclamation_diamond_default = { render };
//#endregion
export { interface_alert_exclamation_diamond_default as default, render };

//# sourceMappingURL=interface-alert-exclamation-diamond.svg.js.map